import { Utils, CustomUIEvent } from '@pacem/pacem-core';
import { Point, Matrix2D } from '@pacem/pacem-foundation';
export function isDrawable(object) {
    return !Utils.isNull(object) && 'stage' in object;
}
export function isUiObject(object) {
    return /*'transformMatrix' in object &&*/ isDrawable(object);
}
function isGradient(object) {
    return 'stops' in object && Utils.isArray(object.stops);
}
export function isLinearGradient(object) {
    return isGradient(object) && 'start' in object && Point.isPoint(object.start)
        && 'end' in object && Point.isPoint(object.end);
}
export function isRadialGradient(object) {
    return isGradient(object) && 'center' in object && Point.isPoint(object.center)
        && 'radius' in object && typeof object.radius === 'number';
}
export class PresentationState {
    static combine(lhs, rhs, precomputedMatrix = null) {
        return {
            opacity: (lhs.opacity ?? 1) * (rhs.opacity ?? 1),
            transformMatrix: precomputedMatrix ?? Matrix2D.multiply(rhs.transformMatrix, lhs.transformMatrix),
            dashArray: lhs.dashArray ?? rhs.dashArray,
            fill: lhs.fill ?? rhs.fill,
            lineCap: lhs.lineCap ?? rhs.lineCap,
            lineJoin: lhs.lineJoin ?? rhs.lineJoin,
            lineWidth: lhs.lineWidth ?? rhs.lineWidth,
            stroke: lhs.stroke ?? rhs.stroke
        };
    }
}
export function isPresentationObject(object) {
    return isUiObject(object)
        && ('fill' in object
            || 'transformMatrix' in object
            || 'stroke' in object
            || 'lineJoin' in object
            || 'dashArray' in object
            || 'lineWidth' in object
            || 'opacity' in object
            || 'lineCap' in object);
}
export function isShape(object) {
    return isUiObject(object) && 'pathData' in object;
}
export function isGroup(object) {
    return isUiObject(object) && 'childDrawables' in object && !Utils.isNullOrEmpty(object['childDrawables']);
}
export function isText(object) {
    return isUiObject(object) && 'text' in object && typeof object['text'] === 'string';
}
export function isImage(object) {
    return isUiObject(object) && 'src' in object && typeof object['src'] === 'string';
}
export class UI2DEvent extends CustomUIEvent {
    constructor(type, eventInit, originalEvent, transformMatrix) {
        super(type, eventInit, originalEvent);
        this.#transformMatrix = transformMatrix;
    }
    #transformMatrix;
    /** Gets the screen transform matrix. */
    get transformMatrix() {
        return this.#transformMatrix;
    }
    project(pt = { x: this.screenX, y: this.screenY }) {
        return Matrix2D.multiply(pt, this.#transformMatrix);
    }
}
export class Shape {
    static empty() {
        return { pathData: '', vertices: [], boundingRect: { x: 0, y: 0, width: 0, height: 0 } };
    }
}
export class DragEvent extends UI2DEvent {
}
export class DrawableEvent extends UI2DEvent {
    constructor(type, args, originalEvent, m) {
        super(type, { detail: args, bubbles: true, cancelable: true }, originalEvent, m);
    }
}
export class StageEvent extends UI2DEvent {
    constructor(type, args, originalEvent, m = args.transformMatrix) {
        super(type, { detail: args, bubbles: true, cancelable: true }, originalEvent, m);
    }
}
